module.exports = __webpack_public_path__ + "static/media/main idea.da4bf1fa.mp3";